













































































import Vue from 'vue';
import { OutlinedSelect, OutlinedTextInput } from '@/components/ds';
import ProuniFileUpload from '@/components/forms/prouni/ProuniFileUpload.vue';
import { searchZipCode } from '@/helpers/externalServices';
import { formatZipCode } from '@/helpers/formatters';
import { UF_LIST, RESIDENCE_PROOF_TYPES } from '@/helpers/prouniOptions';
import { ProuniApplication, ProuniDocumentType } from '@/store/modules/prouni/types';

export default Vue.extend({
  name: 'ProuniResidenceForm',
  components: { OutlinedSelect, OutlinedTextInput, ProuniFileUpload },
  props: {
    application: {
      type: Object as () => ProuniApplication | null,
      default: null,
    },
  },
  data() {
    const app = this.application || {};
    return {
      form: {
        addressZipCode: app.addressZipCode || '',
        addressStreet: app.addressStreet || '',
        addressNumber: app.addressNumber || '',
        addressComplement: app.addressComplement || '',
        addressNeighborhood: app.addressNeighborhood || '',
        addressCity: app.addressCity || '',
        addressState: app.addressState || '',
        residenceProofType: app.residenceProofType || '',
      },
      masks: { addressZipCode: formatZipCode },
      documentTypes: ProuniDocumentType,
      uploaded: {
        residenceProof: (app.documents || []).some(
          d => d.documentType === ProuniDocumentType.residenceProof,
        ),
      },
    };
  },
  computed: {
    ufOptions(): string[] {
      return UF_LIST;
    },
    proofTypeOptions(): string[] {
      return RESIDENCE_PROOF_TYPES;
    },
  },
  mounted() {
    // Emit the initial validity so revisiting a step (already filled) enables Continue.
    this.inputHandler();
  },
  methods: {
    setResidenceProofDone(done: boolean) {
      this.uploaded.residenceProof = done;
      this.inputHandler();
    },
    // Preenche endereço via ViaCEP quando o CEP tem 8 dígitos (searchZipCode
    // retorna null caso contrário). Campos vazios não sobrescrevem o que o
    // usuário já digitou; todos seguem editáveis.
    async zipCodeHandler() {
      const result = await searchZipCode(this.form.addressZipCode);
      if (result) {
        if (result.street) this.form.addressStreet = result.street;
        if (result.neighborhood) this.form.addressNeighborhood = result.neighborhood;
        if (result.city) this.form.addressCity = result.city;
        if (result.uf) this.form.addressState = result.uf;
      }
      this.inputHandler();
    },
    inputHandler() {
      const filledRequired = [
        this.form.addressZipCode,
        this.form.addressStreet,
        this.form.addressNumber,
        this.form.addressNeighborhood,
        this.form.addressCity,
        this.form.addressState,
        this.form.residenceProofType,
      ].every(Boolean);

      const isValid = filledRequired && this.uploaded.residenceProof;

      this.$emit('input', { ...this.form }, isValid);
    },
  },
});
